/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Empty_TitleInputs */

const en_blog_empty_title = /** @type {(inputs: Blog_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first stories are on their way`)
};

const pl_blog_empty_title = /** @type {(inputs: Blog_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwsze teksty są w drodze`)
};

/**
* | output |
* | --- |
* | "The first stories are on their way" |
*
* @param {Blog_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_empty_title = /** @type {((inputs?: Blog_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_empty_title(inputs)
	return en_blog_empty_title(inputs)
});